export default function SavedDesignsIcon() {
  return (
    <svg viewBox="0 0 21.87 17.94" className="eighteen">
      <path d="M21,3.13H11.18L7.98,.06s-.09-.06-.15-.06H.88C.39,0,0,.39,0,.88V17.06c0,.48,.39,.87,.88,.87H21c.48,0,.87-.39,.88-.87V4c0-.48-.39-.87-.88-.87M7.12,1.97l1.21,1.16H1.97V1.97H7.12Zm12.78,14H1.97V5.1H19.91V15.97Z" />
    </svg>
  );
}
